var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$media.loaded
    ? _c("div")
    : _vm.pendingMovies.length > 0
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "flex justify-between items-center" },
            [
              _c("BasePageHeader", [_vm._v("Watch next:")]),
              _c("BaseMenu", {
                attrs: { direction: "top-right", options: _vm.sortingOptions },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var toggleSortingMenu = ref.toggle
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "flex items-center h-8",
                            on: { click: toggleSortingMenu }
                          },
                          [
                            _c("span", { staticClass: "mr-1 text-sm" }, [
                              _vm._v(_vm._s(_vm.sortingText))
                            ]),
                            _c("BaseIcon", {
                              staticClass: "w-5 h-5",
                              attrs: { name: "cheveron-down" }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("MoviesGrid", {
            ref: "movies-grid",
            attrs: { movies: _vm.pendingMoviesSummary }
          }),
          _vm.pendingMovies.length > _vm.pendingMoviesSummary.length
            ? _c(
                "p",
                {
                  staticClass:
                    "mt-3 leading-relaxed max-w-readable text-center desktop:text-left"
                },
                [
                  _vm._v(" You can find more movies in "),
                  _c("BaseLink", { attrs: { route: "collection" } }, [
                    _vm._v(" your collection ")
                  ]),
                  _vm._v(". ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : !_vm.$media.empty
    ? _c(
        "div",
        {
          staticClass:
            "max-w-readable mx-auto text-center items-center flex flex-col flex-grow justify-center -mt-10"
        },
        [
          _c("BasePageHeader", [_vm._v(" All done! ")]),
          _c(
            "div",
            { staticClass: "bg-green-300 rounded-full p-3 mb-4" },
            [
              _c("BaseIcon", {
                staticClass: "w-12 h-12 text-green-600",
                attrs: { name: "checkmark" }
              })
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "leading-relaxed" },
            [
              _vm._v(" You don't have anything pending to watch! Check "),
              _c("BaseLink", { attrs: { route: "collection" } }, [
                _vm._v(" your collection ")
              ]),
              _vm._v(" to rewatch some of your favourites or "),
              _c("span", { staticClass: "hidden desktop:inline-block" }, [
                _vm._v('press "s" to find something new')
              ]),
              _c(
                "BaseLink",
                {
                  staticClass: "desktop:hidden",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$search.start()
                    }
                  }
                },
                [_vm._v(" find something new ")]
              ),
              _vm._v(". ")
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "flex flex-col flex-grow w-full max-w-readable mx-auto mb-4"
        },
        [
          _c("BasePageHeader", [_vm._v("Welcome to Media Kraken!")]),
          _vm._m(0),
          _c("p", { staticClass: "text-gray-800 mb-3 leading-relaxed" }, [
            _vm._v(
              " Let's get started. Do you have any movies that you would like to add to your collection? "
            )
          ]),
          _c(
            "BaseButton",
            {
              staticClass:
                "\n            border border-primary-500 text-sm text-primary-700 justify-center my-4\n            hover:bg-black-overlay\n        ",
              on: { click: _vm.importMedia }
            },
            [_vm._v(" Yes, I have some movies I'd like to import ")]
          ),
          _c(
            "BaseButton",
            {
              staticClass:
                "\n            border border-primary-500 text-sm text-primary-700 justify-center\n            hover:bg-black-overlay\n        ",
              on: { click: _vm.seedCollection }
            },
            [_vm._v(" No, just give me something to watch ")]
          )
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-gray-800 mb-3 leading-relaxed" }, [
      _vm._v(
        " I will help you keep track of your movies so that you don't miss a beat. But there's a catch, you'll only find "
      ),
      _c("span", { staticClass: "font-medium" }, [_vm._v("your movies")]),
      _vm._v(" here. And only you can put movies in your collection! ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }